import Context from "@/context/Context";
import PageHead from "@/pages/Head";
import Store from "@/redux/store";
import { Provider } from "react-redux";
import BreadCrumb from "@/components/Common/BreadCrumb";
import Separator from "@/components/Common/Separator";
import FooterOne from "@/components/Footer/Footer-One";
import HeaderBasic from "@/components/Header/HeaderStyle-Four";
import MobileMenu from "@/components/Header/MobileMenu";
import TeamFour from "@/components/Team/TeamFour";
import BackToTop from "@/pages/backToTop";

const InstructorPage = () => {
  return (
    <>
      <PageHead title="Nuestro Equipo - Colegio Menfis" />
      <Provider store={Store}>
        <Context>
          <HeaderBasic headerSticky="rbt-sticky" headerType="" />
          <MobileMenu />
          <BreadCrumb title="Our Team" text="Our Team" />
          <div className="rbt-team-area bg-color-white rbt-section-gapTopHalf">
            <TeamFour isHead/>
          </div>
          <BackToTop />
          <Separator />
          <FooterOne />
        </Context>
      </Provider>
    </>
  );
};

export default InstructorPage;
